import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { CommonDataService } from '../appDataServices/commonDataService';
import { APPCONFIG, Config } from '../_store';
import { StorageService } from './storage.service';
import { UtilityService } from './utility.service';

@Injectable({
    providedIn: 'root'
})
export class DynamicDataTranslationService {
    private currentDynamicLabels = {};
    constructor(
        private utilityService: UtilityService,
        private translateService: TranslateService
    ) {
    }

    initData() {
        this.utilityService.httpGet(APPCONFIG.urls.dynamicDataTranslationURL, {}).subscribe(labels => {
            this.currentDynamicLabels = labels;
            console.log(this.currentDynamicLabels);
        });
    }

    getTranslatedTextForData(dataValue) {
        if (this.currentDynamicLabels[dataValue]) {
            const translatedText = this.translateService.instant(this.currentDynamicLabels[dataValue]);
            if (translatedText.indexOf('LABELS.') !== -1) {
                return dataValue;
            } else {
                return translatedText;
            }
        } else {
            return dataValue;
        }
    }

    getTranslatedTextForLabel(label, defaultVal = '', options = {}) {
        const translatedText = this.translateService.instant(label, options)
        if (translatedText === label) {
            return defaultVal || label;
        } else {
            return translatedText;
        }
    }



}
